/* @flow */
import * as React from 'react';
import { css } from 'linaria';

import Colors from '../../constants/Colors';
import { BodyText, Button, Container, Image, Title } from '../../components/core';
import MediaQueries from '../../constants/MediaQueries';

function BecomeALuggerBlock() {
  return (
    <div className={Styles.Container}>
      <div className={Styles.Background}>
        <div className={Styles.BackgroundGradient} />
        <Image
          src={require('../../../assets/images/photos/luggers-small-01.jpg')}
          src2x={require('../../../assets/images/photos/luggers-small-01_2x.jpg')}
          className={Styles.BackgroundImage}
        />
      </div>
      <div className={Styles.Content}>
        <Container className={Styles.ContentContainer}>
          <Title size="40" color={Colors.White} className={Styles.TextAlign} weight="bold">
            Become a Lugger
          </Title>
          <BodyText
            size="18"
            color={Colors.opacity(Colors.White, 0.7)}
            className={Styles.TextAlign}>
            Be active, meet new people & make up to $2.5k/week
          </BodyText>
          <Button
            theme="white"
            className={Styles.Button}
            icon="arrow-white-right"
            to="/become-a-lugger">
            Become a Lugger
          </Button>
        </Container>
      </div>
    </div>
  );
}

const Styles = {
  Container: css`
    background-color: ${Colors.IndigoDark};
    border-radius: 10px;
    position: relative;
    overflow: hidden;
    text-align: center;
    ${MediaQueries.Medium} {
      height: 240px;
      text-align: left;
    }
  `,
  Content: css`
    padding: 0 30px 30px;
    ${MediaQueries.Medium} {
      position: absolute;
      top: 0;
      bottom: 0;
      left: 0;
      right: 0;
      padding: 36px;
    }
  `,
  ContentContainer: css`
    text-align: center;
    ${MediaQueries.Medium} {
      text-align: left;
    }
  `,
  Background: css`
    position: relative;
    ${MediaQueries.Medium} {
      position: absolute;
      top: 0;
      bottom: 0;
      right: 0;
    }
    ${MediaQueries.Large} {
      right: 12.5%;
    }
  `,
  BackgroundImage: css`
    width: 100%;
    ${MediaQueries.Medium} {
      max-width: 560px;
      margin-top: -60px;
    }
  `,
  BackgroundGradient: css`
    position: absolute;
    top: 0;
    bottom: 0;
    left: 0;
    right: 0;
    background: linear-gradient(0deg, #283060 8%, rgba(39, 47, 96, 0) 34%);
    ${MediaQueries.Medium} {
      background: linear-gradient(
        90deg,
        #283060 12%,
        rgba(39, 47, 96, 0) 34%,
        rgba(39, 47, 96, 0) 73%,
        #283060 93%
      );
    }
  `,
  TextAlign: css`
    text-align: center;
    ${MediaQueries.Medium} {
      text-align: left;
    }
  `,
  Button: css`
    margin-top: 22px;
  `,
};

export default BecomeALuggerBlock;



// WEBPACK FOOTER //
// ./src/ui/pages/components/BecomeALuggerBlock.js